export interface PollingOptions {
  pollInterval: number;
  timeout: number;
}

export interface DownloadCallbacks {
  onSuccess: (response: any) => void;
  onError: () => void;
  onTimeout: () => void;
  onCleanup: (id: string, notificationKey: string) => void;
}

export enum DownloadStatus {
  STARTED = "STARTED",
  RUNNING = "RUNNING",
  FINISHED = "FINISHED",
  FAILED = "FAILED",
}

export interface DownloadResponse {
  status: DownloadStatus;
  link?: string;
  name: string;
  message?: string;
  progress?: number;
}
